import React from 'react'

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null }
        this.reset = this.reset.bind(this)
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error }
    }

    componentDidCatch(error, info) {
        if (this.props.onError) this.props.onError(error, info)
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.reset()
        }
    }

    reset() {
        this.setState({ hasError: false, error: null })
    }

    render() {
        if (this.state.hasError) {
            const { fallback } = this.props
            if (typeof fallback === 'function') {
                return fallback({ error: this.state.error, reset: this.reset })
            }
            return fallback || null
        }

        return this.props.children
    }
}
